import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { fillRed } from '../../utils/contrastSvgAttributes';

const PriorityHighIcon: React.FC<{ color?: string }> = ({ color }) => {
  return <NotificationsActiveOutlinedIcon fontSize="small" style={{ width: '0.8em', color: color ?? fillRed }} />;
};

export default PriorityHighIcon;
